export default "__VITE_ASSET__CgVzIG5___"